var initESW = function (gslbBaseURL) {
  embedded_svc.settings.displayHelpButton = true; //Or false
  embedded_svc.settings.language = ''; //For example, enter 'en' or 'en-US'

  //embedded_svc.settings.defaultMinimizedText = '...'; //(Defaults to Chat with an Expert)
  //embedded_svc.settings.disabledMinimizedText = '...'; //(Defaults to Agent Offline)

  //embedded_svc.settings.loadingText = ''; //(Defaults to Loading)
  //embedded_svc.settings.storageDomain = 'yourdomain.com'; //(Sets the domain for your deployment so that visitors can navigate subdomains during a chat session)

  // Settings for Chat
  //embedded_svc.settings.directToButtonRouting = function(prechatFormData) {
  // Dynamically changes the button ID based on what the visitor enters in the pre-chat form.
  // Returns a valid button ID.
  //};
  //embedded_svc.settings.prepopulatedPrechatFields = {}; //Sets the auto-population of pre-chat form fields
  //embedded_svc.settings.fallbackRouting = []; //An array of button IDs, user IDs, or userId_buttonId
  //embedded_svc.settings.offlineSupportMinimizedText = '...'; //(Defaults to Contact Us)

  embedded_svc.settings.enabledFeatures = ['LiveAgent'];
  embedded_svc.settings.entryFeature = 'LiveAgent';

  embedded_svc.init('https://legrandav.my.salesforce.com', 'https://legrandav.my.site.com/requestforreturn', gslbBaseURL, '00D600000007Dpt', 'Live_Chat_Group', {
    baseLiveAgentContentURL: 'https://c.la1-core1.sfdc-yfeipo.salesforceliveagent.com/content',
    deploymentId: '572Pk0000005pOT',
    buttonId: '573Pk0000001a1R',
    baseLiveAgentURL: 'https://d.la1-core1.sfdc-yfeipo.salesforceliveagent.com/chat',
    eswLiveAgentDevName: 'Live_Chat_Group',
    isOfflineSupportEnabled: true,
  });
};

if (!window.embedded_svc) {
  var s = document.createElement('script');
  s.setAttribute('src', 'https://legrandav.my.salesforce.com/embeddedservice/5.0/esw.min.js');
  s.onload = function () {
    initESW(null);
  };
  document.body.appendChild(s);
} else {
  initESW('https://service.force.com');
}
